import Toast from 'bootstrap/js/dist/toast';

(function () {
    const toastElList = document.querySelectorAll('.toast');
    toastElList.forEach((toastEl) => new Toast(toastEl).show());
})();
